import { Button } from '@mui/material';
import styled from 'styled-components';
import { darkBlue, primaryBlue, primaryText } from '../models/colors';

interface IStyledProps {
	height: number;
}

export const StyledButton = styled(({ color, variant, children, ...rest }: any & IStyledProps) => (
	<Button
		color={color ? color : 'primary'}
		variant={variant ? variant : 'contained'}
		sx={{
			color: primaryText,
			backgroundColor: primaryBlue,
			fontFamily: 'Roboto, san-serif',
		}}
		{...rest}
	>
		{children}
	</Button>
))`
  & {
    height: ${p => (p.height ? p.height : '48px')};
    transition: background-color 150ms ease-in-out;
  }

  &:hover {
    background-color: ${darkBlue};
  }
`;
